const accordions = document.querySelectorAll('.js-block-accordion');
const accordionItems = document.querySelectorAll('.js-block-accordion-item__handle');
if (accordions) {
  [].forEach.call(accordions, (accordion) => setInitialOpen(accordion));
  [].forEach.call(accordionItems, (accordionItem) => accordionItem.addEventListener('click', toggleAccordion));
}

function setInitialOpen(accordion) {
  const initialOpen = parseInt(accordion.getAttribute('data-initial-open'));
  const firstAccordionItem = accordion.children[0];

  if (initialOpen && firstAccordionItem) {
    firstAccordionItem.classList.add('is-open');
    firstAccordionItem.querySelector('.js-block-accordion-item__handle').setAttribute('aria-expanded', true)
  }
}

function toggleAccordion(event) {
  const accordionItem = event.target;

  accordionItem.parentNode.classList.toggle('is-open');
  accordionItem.setAttribute('aria-expanded', accordionItem.getAttribute('aria-expanded') === 'false');
  accordionItem.nextElementSibling.toggleAttribute('hidden');
}